<template>
  <div class="outline">
    <Banner></Banner>
  </div>
</template>

<script>
import Banner from "../../components/common/banner";
export default {
  name: "OutLine",
  components: { Banner },
  data() {
    return {
      classNameA: "colA",
      classNameB: "colA",
      classNameC: "colA",
      classNameD: "colA"
    };
  },
  methods: {
    openTypeLise(type) {
      this.$store.commit("setTabPage", type);
      let name = "TabHotel";
      this.$emit("specialtyListFunction", name);
    }
  }
};
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/hotel/index.vue